import { useStaticQuery, graphql } from 'gatsby';

const useLogos = () => {
  const data = useStaticQuery(graphql`
    query useLogosQuery {
      sanityLogos {
        favicon {
          alt
          imageType
          asset {
            url
            gatsbyImageData(placeholder: BLURRED, formats: WEBP)
          }
        }
        footer {
          alt
          imageType
          asset {
            url
            gatsbyImageData(placeholder: BLURRED, formats: WEBP)
          }
        }
        navbar {
          alt
          imageType
          asset {
            url
            gatsbyImageData(placeholder: BLURRED, formats: WEBP, height: 48)
          }
        }
      }
    }
  `);

  const logos = data.sanityLogos;

  return logos;
};

export { useLogos };
